import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=bedd4dec&scoped=true&"
import script from "./Customer.vue?vue&type=script&lang=js&"
export * from "./Customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedd4dec",
  null
  
)

component.options.__file = "Customer.vue"
export default component.exports